import { useLocation } from "react-router";
import s from "./SplitCostingWizardStepper.module.css";

const BASE_PATH = "/onboarding/split-costing-import";

/**
 * The "Company context" step is handled as an inline gate in the layout
 * (matching `PayComponentImportLayout`) rather than as a separate wizard step,
 * so the stepper starts at "Upload".
 */
const STEPS = [
  { label: "Upload" },
  { label: "Validate & commit" },
  { label: "Result" },
] as const;

function useActiveStepIndex(): number {
  const { pathname } = useLocation();
  const suffix = pathname.replace(BASE_PATH, "");
  if (suffix === "/validate") return 1;
  if (suffix === "/result") return 2;
  return 0;
}

type StepStatus = "pending" | "active" | "completed";

/**
 * Read-only step indicator for the split costing import wizard. Active step is
 * derived from the current route. Later steps appear as disabled placeholders
 * until the preceding step is complete.
 */
export function SplitCostingWizardStepper() {
  const activeIndex = useActiveStepIndex();

  return (
    <nav aria-label="Split costing import progress">
      <ol className={s.stepper}>
        {STEPS.map((step, index) => {
          const status: StepStatus =
            index < activeIndex
              ? "completed"
              : index === activeIndex
                ? "active"
                : "pending";
          return (
            <li
              key={step.label}
              className={`${s.step} ${s[status]}`}
              aria-current={status === "active" ? "step" : undefined}
            >
              <span className={s.stepNumber} aria-hidden="true">
                {status === "completed" ? "✓" : `${index + 1}.`}
              </span>
              <span className={s.stepText}>{step.label}</span>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
